(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-selector"] && !Shopify.designMode) return;
  try {
    document.querySelector('#CustolumeLanguageForm')?.addEventListener('submit',event=>{const form=event.currentTarget;const input=form.querySelector('[name="return_to"]');if(input)input.value=location.pathname+location.search+location.hash;});
  } catch(e) { console.error(e); }
})();

})();
